<template>
  <div class="scmcc-header">
    <CIcon v-if="!$store.state.main.sidebar.fold" class="scmcc-sidebar-toggle" icon="caidan-shouqi" @click="toggleSidebarFold"></CIcon>
    <CIcon v-else class="scmcc-sidebar-toggle" icon="caidan-zhankai" @click="toggleSidebarFold"></CIcon>
    <div class="scmcc-header-center">
      <component
        v-for="(value, key) in $store.state.dynamicComponent.HEADER_CENTER"
        :key="key"
        :is="value"
      >
      </component>
      <sccsEndSuperOrInsert></sccsEndSuperOrInsert>
    </div>
    <div class="scmcc-header-rightmenu">
      <div style = "display:inline-block;height:100%;" id = '_onlineServiceEmbed'></div>
      <component
        class="scmcc-header-rightmenu-item"
        v-for="(value, key) in $store.state.dynamicComponent.HEADER_RIGHT_MENUS"
        :key="key"
        :is="value"
      ></component>
      <Downguide style="margin-right: 16px;"></Downguide>
      <Entrance></Entrance>
      <CUserCenterEntry class="scmcc-header-rightmenu-item"></CUserCenterEntry>
    </div>
  </div>
</template>
<script>
import CUserCenterEntry from '../UserCenterEntry'
import Entrance from '../NoticeCenter/'
import Downguide from '../DownCenter/'
import CCarousel from './Carousel'
export default {
  name: 'Cheader',
  components: {
    CUserCenterEntry,
    CCarousel,
    Entrance,
    Downguide
  },
  data: () => ({}),
  created() {},
  methods: {
    goHome() {
      this.$router.push('/')
    },
    toggleSidebarFold() {
      this.$store.commit(
        'main/sidebar/setFold',
        !this.$store.state.main.sidebar.fold
      )
    },
    callGlobalDemo(event) {
      this.$eventBus.emit('dynamicComponent/call/globalDemo', {
        placeholder: '请输入值',
        event,
        onOk: value => {
          console.log(`在全局组件中输入的值为：${value}`)
        }
      })
    }
  }
}
</script>

<style lang="stylus">
.scmcc-header
  position relative
  z-index 10
  display flex
  align-items center
  flex 0 0 64px
  width 100%
  color #515A6E
  user-select none
  background #fff
  background rgba(255, 255, 255, 1)
  box-shadow 5px 2px 8px 0px rgba(218, 225, 244, 1)

  .scmcc-sidebar-toggle
    margin 0 20px
    cursor pointer
    font-size 20px

  .scmcc-header-center
    flex auto

  .scmcc-header-rightmenu
    display flex
    justify-content flex-end
    align-items center
    flex auto

  .scmcc-header-rightmenu-item
    display flex
    align-items center
    font-size 14px
    cursor pointer
    padding 0 17px
</style>
